export default "__VITE_ASSET__9b905d28__"